export const checklistKey = q => q.frontend_key || (q.extra_question_id ? `extra-${q.extra_question_id}` : `q-${q.question_id || q.id}`);
export function questionHasAnswer(q, answers = {}, files = []) {
  const key = checklistKey(q), answer = answers[key];
  if (q.question_type === 'photo') return files.some(f => (f.frontend_key || (f.extra_question_id ? `extra-${f.extra_question_id}` : `q-${f.question_id}`)) === key);
  if (!answer) return false;
  if (q.question_type === 'yesno') return answer.value_bool !== null && answer.value_bool !== undefined;
  if (q.question_type === 'number') return answer.value_number !== null && answer.value_number !== undefined && String(answer.value_number).trim() !== '';
  return Boolean(answer.value_text && String(answer.value_text).trim());
}
export function filterChecklist(sections, answers, files, {query = '', mode = 'all', section = 'all'} = {}) {
  const words = query.toLocaleLowerCase('ru').trim().split(/\s+/).filter(Boolean);
  return sections.flatMap(s => s.questions.filter(q => {
    if (section !== 'all' && String(s.id) !== section) return false;
    const text = `${s.title || ''} ${q.text || ''}`.toLocaleLowerCase('ru');
    if (!words.every(word => text.includes(word))) return false;
    if (mode === 'unanswered') return !questionHasAnswer(q, answers, files);
    if (mode === 'required') return Boolean(q.required);
    if (mode === 'negative') return answers[checklistKey(q)]?.value_bool === false;
    return true;
  }).map(checklistKey));
}
export function nextUnanswered(questions, answers, files, afterKey) {
  const start = questions.findIndex(q => checklistKey(q) === afterKey);
  for (let offset = 1; offset <= questions.length; offset++) {
    const q = questions[(start + offset) % questions.length];
    if (!questionHasAnswer(q, answers, files)) return checklistKey(q);
  }
  return null;
}
